import { render } from "./RecommendedVouchersPage.vue?vue&type=template&id=b1369cc6&scoped=true"
import script from "./RecommendedVouchersPage.vue?vue&type=script&lang=js"
export * from "./RecommendedVouchersPage.vue?vue&type=script&lang=js"

import "./RecommendedVouchersPage.vue?vue&type=style&index=0&id=b1369cc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1369cc6"]])

export default __exports__